import { AssistantChat } from 'sonata-platform-components';
import { useFeatureUser } from 'sonata-react-components';

import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors';
import { getUserRoles } from '@/store/global/userRoles/selectors';

import './entityListAssistantChat.scss';

type Props = {
  agentId: string;
  id: string;
  buttonText: string;
  startUpMessageText?: string;
};

export function EntityListAssistantChat({ agentId, id, buttonText, startUpMessageText }: Readonly<Props>) {
  const user = useGlobalStore(getUser);
  const userRoles = useGlobalStore(getUserRoles);
  const useAssistantChat = useFeatureUser('MTFListAssistantChat');

  if (!user || !userRoles || !useAssistantChat) {
    return null;
  }

  return (
    <div className="entityListAssistantChat">
      <AssistantChat
        buttonText={buttonText}
        defaultAgentId={agentId}
        id={id}
        loadingData={false}
        startUpMessageText={startUpMessageText}
        user={user.toJSON()}
        userRoles={userRoles}
      />
    </div>
  );
}
